import { apiBusSchedBaseURL } from '../../authentication/Global';
import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class SimpleTextAPI {
    constructor(appName) {
        switch (appName) {
            case "bussched":
                this.baseUrl = new URL("bussched/simpletexts/", apiBusSchedBaseURL);
                break;
            case "schematicmap":
                this.baseUrl = new URL("schematicmap/simpletexts/", apiSchematicMapBaseURL);
                break;
            default:
                this.baseUrl = new URL("");
                break;
        }
    }

    create(simpleText) {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(simpleText)
        });
    }

    update(simpleTextId, simpleText) {
        return API.authenticatedRequest({
            url: new URL(simpleTextId, this.baseUrl),
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(simpleText)
        });
    }

    delete(simpleTextId) {
        return API.authenticatedRequest({
            url: new URL(simpleTextId, this.baseUrl),
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    list() {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}